import { render, staticRenderFns } from "./pengajuanEdit.vue?vue&type=template&id=0bf7b646&scoped=true"
import script from "./pengajuanEdit.vue?vue&type=script&lang=js"
export * from "./pengajuanEdit.vue?vue&type=script&lang=js"
import style0 from "./pengajuanEdit.vue?vue&type=style&index=0&id=0bf7b646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7b646",
  null
  
)

export default component.exports